import { render, staticRenderFns } from "./FormControlModulecomponentsTitleColumn.vue?vue&type=template&id=08b78aad"
import script from "./FormControlModulecomponentsTitleColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulecomponentsTitleColumn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports